import { SchedulingPolicy } from '@ardoq/api-types';
import styled from 'styled-components';
import { type I18nLocale, t } from '@ardoq/i18n';
import {
  cronPolicyToScheduleState,
  migrateDeprecatedSchedulingPolicy,
} from '../schedulePolicySelector/utils';
import { getWeekDayLabel } from '../schedulePolicySelector/labels';

const Capitalized = styled.div`
  text-transform: capitalize;
`;

type SchedulePolicyProps = {
  schedulingPolicy: SchedulingPolicy;
  i18nLocale: I18nLocale;
};

export const SchedulePolicy = ({
  schedulingPolicy,
  i18nLocale,
}: SchedulePolicyProps) => {
  const cronPolicy = migrateDeprecatedSchedulingPolicy(schedulingPolicy);
  const scheduleState = cronPolicyToScheduleState(cronPolicy);

  return (
    <Capitalized>
      {scheduleState.scheduleType === 'weekly'
        ? t(
            i18nLocale,
            'integrations:schedulePolicy.everyWeekday',
            { weekDay: getWeekDayLabel(i18nLocale, scheduleState.weekDay) },
            'Every {{weekDay}}'
          )
        : t(i18nLocale, 'integrations:schedulePolicy.daily', 'Daily')}
    </Capitalized>
  );
};
